// Lib
import gql from 'graphql-tag';

// Types
import { ACCOUNT } from '../types';

const getAccountQueryString = `
  query GetAccount {
    me {
      ${ACCOUNT}
    }
  }
`;

export const getAccountQuery = gql`
  ${getAccountQueryString}
`;

export const logoutFromApp = (app) => gql`
  query ${app.capitalize()}Logout {
    ${app}Logout
  }
`;

export const getUsersByName = gql`
  query FindUserByName($searchString: String!) {
    findUserByName(searchString: $searchString) {
      shareableSettings {
        avatar {
          _id
          url
          mimetype
        }
        username
        fullName
      }
    }
  }
`;

export const getLinkPreview = gql`
  query GetLinkPreview($url: String!) {
    getLinkPreview(url: $url) {
      createdAt
      updatedAt
      url
      title
      description
      favicon
      media {
        url
        s3Key
      }
    }
  }
`;

export const checkContactInfo = gql`
  query checkContactInfo($input: AccountContactInput!) {
    checkContactInfo(input: $input)
  }
`;

export const getAccountByNameQuery = gql`
  query GetAccount($input: GetAccountInput) {
    getAccount(input: $input) {
      ${ACCOUNT}
    }
  }
`;

export const viewAccountTooltip = gql`
  mutation viewAccountTooltip($input: ViewAccountTooltip) {
    viewAccountTooltip(input: $input)
  }
`;

export const getCountryQuery = gql`
  query getCountry {
    getCountry
  }
`;

export const getMarkupQuery = gql`
  query GetMarkup {
    me {
      backgroundSettings {
        markup {
          tabs {
            type
            name
            visible
            order
            extra {
              authId
              source
            }
          }
        }
      }
    }
  }
`;
